<template>
    <div class="h-100">
        <Subnav :links="links">
        </Subnav>

        <b-container fluid class="h-100">
            <router-view></router-view>
        </b-container>

    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Subnav from '@/components/Nav/Subnav';
import * as permissions from '@/config/permission';

export default {
  name: 'MyAccount',
  components: {
    Subnav,
  },
  data() {
    return {
      links: [
        {
          label: 'My Apps',
          route: { name: 'apps' },
          hasAccess: () => this.$can(
            permissions.APPLICATIONS_CREATE_APP,
            permissions.PERMISSION_TYPE_APPS,
          ),
        },
        {
          label: 'API Credentials',
          route: { name: 'machine-apps' },
          hasAccess: () => this.$can(
            permissions.APPLICATIONS_CREATE_MACHINE_APP,
            permissions.PERMISSION_TYPE_APPS,
          ),
        },
      ],
    };
  },
  computed: {
    ...mapGetters({ user: 'authUser' }),
  },
  mounted() {
    this.fetchUser();
  },
  methods: {
    ...mapActions(['fetchUser']),
    isActiveRoute(routeName) {
      return this.$route.name.includes(routeName);
    },
  },
};
</script>

<style>

</style>
